import { AxiosResponse } from 'axios';
import { ResponseGetTrends, ResponseGetTrendDetail } from '@/types/api';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

export type GetTrendDetailProps = {
  questionId: number | string;
  month?: number | string;
};

const getTrends = async (): Promise<AxiosResponse<ResponseGetTrends>> => {
  const { data, error } = await supabase.rpc('rpc_get_trends');

  if (error) throw error;
  return asResponse<ResponseGetTrends>({ trends: data || [] });
};

const getTrendDetail = async ({
  questionId,
  month = 6,
}: GetTrendDetailProps): Promise<AxiosResponse<ResponseGetTrendDetail>> => {
  const { data, error } = await supabase.rpc('rpc_get_trend_detail', {
    p_question_id: String(questionId),
    p_months: Number(month),
  });

  if (error) throw error;

  if (data?.trend) {
    return asResponse<ResponseGetTrendDetail>(data);
  }

  // Fallback if no data
  return asResponse<ResponseGetTrendDetail>({
    trend: {
      id: String(questionId),
      label: '',
      startDate: '',
      endDate: '',
      answerAvg: 0,
    },
  });
};

export default {
  getTrends,
  getTrendDetail,
};
